import React from 'react';
import PropTypes from 'prop-types';
import {useDraggable} from '@dnd-kit/core';
import {contentUtils, HTMLContent} from "mindsets-js-sdk";

function DnDDraggableItem({item}) {
    const {attributes, listeners, setNodeRef, transform} = useDraggable({
        id: item.dnd_id,
        data: {type: '123'}
    });

    function getDraggableStyle(default_style) {
        return {
            transform: transform ? `translate3d(${transform.x}px, ${transform.y}px, 0)` : undefined,
            cursor: 'grab',
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "0",
            minHeight: "50px",
            minWidth: "50px",
            borderRadius: "4px",
            position: "relative",
            zIndex: 1,
            ..._.get(item, 'draggable_style'),
            ...default_style
        }
    }

    function getContent() {
        const contentImage = _.get(item, 'content.image');
        const contentHtml = _.get(item, 'content.html');
        if (contentImage) {
            return (
                <img src={contentImage} alt={'DND option'}/>
            )
        } else if (contentHtml) {
            return <HTMLContent html_str={contentUtils.processStringContent(contentHtml)}/>;
        } else {
            return null;
        }
    }

    return (
        <div
            ref={setNodeRef}
            className="dnd-option"
            style={getDraggableStyle()}
            {...listeners}
            {...attributes}
        >
            {getContent()}
        </div>
    );
}

DnDDraggableItem.propTypes = {
    item: PropTypes.shape({
        dnd_id: PropTypes.string.isRequired,
        content: PropTypes.shape({
            image: PropTypes.string,
            html: PropTypes.string
        }).isRequired,
    }).isRequired
}

export default DnDDraggableItem
